import { useState } from 'react'
import toast from 'react-hot-toast'
import { productionApi, type ProductionGenealogy, type ProductionOutputContainer } from '@/lib/production-api'

export function Genealogy({ data }: Readonly<{ data: ProductionGenealogy }>) {
  return <div className="space-y-2 break-words rounded border p-3 text-sm">
    <p className="font-semibold">{data.item} · {data.lot} · {data.quantity} {data.unit}</p>
    <p>Disponível (deduz rascunhos): {data.available_quantity} {data.unit}</p>
    <p>Origens por sessão: não representam distribuição exata de matéria-prima por contentor.</p>
    {data.sessions.map(session => <details key={session.session_id}>
      <summary className="cursor-pointer">OP {session.production_order} · {session.operation} · {session.produced_quantity} {session.production_unit}</summary>
      <ul className="ml-4 list-disc">
        {session.consumptions.map((line, index) => <li key={index}>
          {line.item} · Lote {line.lot} · {line.quantity} {session.consumption_unit}
          <span className="block break-all text-xs">Contentor: {line.container_reference}</span>
        </li>)}
      </ul>
    </details>)}
  </div>
}

function OutputContainer({ output, disabled }: Readonly<{ output: ProductionOutputContainer; disabled: boolean }>) {
  const [busy, setBusy] = useState(false)
  const [trace, setTrace] = useState<ProductionGenealogy>()
  const [error, setError] = useState('')

  async function load(label: boolean) {
    setBusy(true)
    setError('')
    try {
      if (label) {
        const pdf = await productionApi.label(output.id)
        const url = URL.createObjectURL(pdf)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `contentor-${output.id}.pdf`
        anchor.click()
        window.setTimeout(() => URL.revokeObjectURL(url), 60000)
        toast.success('PDF obtido. Abra-o e imprima a 100%, sem ajustar à página.')
      } else {
        setTrace(await productionApi.genealogy(output.id))
      }
    } catch {
      setError('Não foi possível obter a etiqueta/genealogia. Tente novamente; o identificador não será alterado.')
    } finally {
      setBusy(false)
    }
  }

  return <div className="space-y-2 rounded border p-3">
    <p className="font-medium">Contentor {output.sequence} · {output.quantity} {output.unit}</p>
    <p className="break-all text-sm">Lote Hub: {output.lot}</p>
    <p className="break-all text-xs">{output.qr_payload}</p>
    <div className="flex flex-wrap gap-2">
      <button className="btn btn-primary" disabled={disabled || busy} onClick={() => void load(true)}>Etiqueta PDF / imprimir</button>
      <button className="btn btn-secondary" disabled={disabled || busy} onClick={() => void load(false)}>Consultar origens</button>
    </div>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {trace && <Genealogy data={trace} />}
  </div>
}

export function ProductionOutputs({ outputs, disabled }: Readonly<{ outputs: ProductionOutputContainer[]; disabled: boolean }>) {
  return <section className="space-y-3">
    <h3 className="font-semibold">Contentores produzidos / etiquetas</h3>
    <p className="text-sm">Etiqueta 60 × 40 mm. O QR abre a consulta autenticada no Hub. Reimprimir mantém o mesmo contentor. O lote Hub não é um lote lançado no ERP.</p>
    {!outputs.length && <p>Este registo anterior não tem contentores de saída. Não serão criados retroativamente.</p>}
    {outputs.map(output => <OutputContainer key={output.id} output={output} disabled={disabled} />)}
  </section>
}
